import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import _ from 'lodash';
import { MapDefaultOptionsDirective } from '../../directives/map-default-options.directive';
import { MapLoaderService } from '../../services/map-loader.service';

interface MapComponentSimpleChanges extends SimpleChanges {
  latitude: SimpleChange;
  longitude: SimpleChange;
}

@Component({
  selector: 'osp-map',
  standalone: true,
  imports: [GoogleMapsModule, AsyncPipe, MapDefaultOptionsDirective],
  templateUrl: './map.component.html',
  styleUrl: './map.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapComponent implements OnChanges {
  @Input() latitude?: number;
  @Input() longitude?: number;
  @Input() zoom = 10;
  @Output() readonly mapInitialized = new EventEmitter<google.maps.Map>();
  public readonly isLoaded = this.mapLoader.isLoaded;
  public center = signal<google.maps.LatLngLiteral>(undefined as unknown as google.maps.LatLngLiteral);
  constructor(private mapLoader: MapLoaderService) { }

  ngOnChanges(changes: MapComponentSimpleChanges): void {
    if (changes.latitude || changes.longitude) {
      if (!_.isNil(this.latitude) && !_.isNil(this.longitude)) {
        this.setCenter(this.latitude, this.longitude);
      }
    }
  }

  setCenter(lat: number, lng: number): void {
    this.center.set({ lat, lng });
  }
}
